import { ReactComponent as RefreshIcon } from "../../assets/icons/voice/reload-arrows.svg";
import { refreshDeviceStatus } from "../../redux/voiceControl-slice";
import { useDispatch } from "react-redux";

export function VoiceDeviceCardRefreshButton({ cloudId, className }) {
  const dispatch = useDispatch();

  function handleRefreshDevice() {
    return dispatch(refreshDeviceStatus(cloudId));
  }
  return <RefreshIcon onClick={handleRefreshDevice} className={className} />;
}
